const kexCommunityState = {
    kexCommunity: undefined,
    requestingKEXCommunity: false
};
export default kexCommunityState;
